import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/badge.svg'
import _imports_1 from '../../assets/night_shelter.svg'
import _imports_2 from '../../assets/list_add_check.svg'


const _withScopeId = n => (_pushScopeId("data-v-2b48a275"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pointer-link item-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-flex align-center header" }
const _hoisted_4 = { class: "text-center ma-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "text-center"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center"
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center ma-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!

  return (_openBlock(), _createBlock(_component_el_header, {
    class: _normalizeClass(["container d-flex justify-space-between", { home: _ctx.isHomeView && !_ctx.isScroll }]),
    height: "70px"
  }, {
    default: _withCtx(() => [
      (_ctx.eventData.themeSettings.logoURL)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.eventData.themeSettings.logoURL,
              height: "30",
              class: "event-photo",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Home' })))
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventFeatures(), (feature, index) => {
          return (_openBlock(), _createBlock(_component_el_button, {
            key: index,
            text: "",
            class: "item-container",
            onClick: ($event: any) => (_ctx.goTo(feature.to))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(feature.title), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128)),
        (!_ctx.isLogged)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.isOnlineRegisterActive && _ctx.optionalOnlineRegisterURL)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    class: "item-container",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToOptionalRegister()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isOnlineRegisterActive)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "text",
                    class: "item-container",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('UserRegister')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.data)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    class: "item-container btn-login",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('Login')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("login.loginTitle")), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_dropdown, { key: 3 }, {
                    dropdown: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.participantData.firstName), 1),
                      _createVNode(_component_el_dropdown_menu, { class: "mt-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('AccountSettings'))),
                            icon: "el-icon-s-tools"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.accountSettings")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goTo('QRIdentification')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.configurationMenu.eventId")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goTo('MyBookings')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6,
                              _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.MyBooking")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goTo('Courses')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7,
                              _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.courses")), 1)
                            ]),
                            _: 1
                          }),
                          (!_ctx.isOnlineRegisterActive && _ctx.optionalOnlineRegisterURL)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToOptionalRegister())),
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isOnlineRegisterActive)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goTo('EventRegister'))),
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            (_ctx.statusPaid)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goTo('Checkout'))),
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("drawer.checkout")), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_el_button, {
                              type: "danger",
                              onClick: _ctx.signOut
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("login.logout")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_avatar, {
                        class: "pointer-link",
                        size: 40,
                        src: _ctx.participantPhoto
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }))
            ], 64))
          : (_openBlock(), _createBlock(_component_el_dropdown, { key: 1 }, {
              dropdown: _withCtx(() => [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.participantData.firstName), 1),
                _createVNode(_component_el_dropdown_menu, { class: "mt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goTo('AccountSettings'))),
                      icon: "el-icon-s-tools"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.accountSettings")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goTo('QRIdentification')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("header.configurationMenu.eventId")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goTo('MyBookings')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.MyBooking")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.goTo('Courses')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.courses")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.statusPaid)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.goTo('Checkout'))),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("drawer.checkout")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        onClick: _ctx.signOut
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("login.logout")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  class: "pointer-link",
                  size: 40,
                  src: _ctx.participantPhoto
                }, null, 8, ["src"])
              ]),
              _: 1
            }))
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}